module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-husk-saphire-7df69990ccc3b32ac596605adeceddb0.svg";